// FILECONTENT_START src/common/components/Inputs/HtmlEditor/HtmlEditor.tsx
//@ts-ignore
import { CKEditor } from "@ckeditor/ckeditor5-react";
//@ts-ignore
import { FormHelperText, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { makeStyles } from "@mui/styles";
//@ts-ignore
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { useEffect, useRef } from "react";
import Spacer from "./../../Spacer/Spacer";
const useStyles = makeStyles((theme: any) => ({
  "@global": {
    ".ck-content": {
      maxHeight: 500,
    },
    ".ck.ck-editor__editable_inline": {
      padding: `0 ${theme.spacing(2)}`,
    },
    ":root": {
      "--ck-border-radius": `${theme.shape.borderRadius}px`,
      "--ck-color-base-background": theme.palette.background.default,
      "--ck-color-toolbar-background": theme.palette.background.default,
      "--ck-color-button-on-background": theme.palette.background.default,
      "--ck-color-button-on-hover-background": theme.palette.background.default,
      "--ck-color-base-text": theme.palette.text.primary,
      "--ck-color-text": theme.palette.text.primary,
      "--ck-color-focus-border": theme.palette.primary.main,
      "--ck-color-button-default-hover-background": theme.palette.action,
      "--ck-z-default": 1000,
      "--ck-z-modal": "calc( var(--ck-z-default) + 999 )",
    },
  },
}));

export interface HtmlEditorProps {
  id?: string;
  value?: string;
  label?: string;
  onChange?: Function;
  onBlur?: Function;
  error?: string;
  helperText?: string;
  minHeight?: number;
  onChangeByKeyPress?: Function;
  useDelayedKeystrokes?: boolean;
  isDirty?: boolean;
  disabled?: boolean;
  required?: boolean;
  config?: any;
}
export default function HtmlEditor({
  value,
  label: _label,
  onChange,
  onBlur,
  error,
  helperText,
  minHeight,
  onChangeByKeyPress,
  useDelayedKeystrokes,
  required,
  ...editorProps
}: HtmlEditorProps) {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles();
  const timerRef = useRef<any>();
  const editorRef = useRef<any>();
  useEffect(() => {
    if (editorRef.current) {
      const currentData = editorRef.current.getData();
      if (currentData !== value) {
        editorRef.current.setData(value || "");
      }
    }
  }, [value]);

  function handleChange(v: any) {
    if (v === value) {
      return;
    }

    const evt = { target: { value: v } };
    onChangeByKeyPress && onChangeByKeyPress(evt);

    if (useDelayedKeystrokes) {
      //evt.persist();
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        onChange && onChange(evt);
      }, 800);
    }
  }

  const handleBlur = (v: any) => {
    if (v === value) {
      return;
    }

    const evt = { target: { value: v } };

    onChange && onChange(evt);
    onBlur && onBlur(evt);
  };
  const label = required ? (
    <span>
      {_label} <span style={{ color: "red" }}>*</span>
    </span>
  ) : (
    _label
  );
  return (
    <FormControl fullWidth error={error ? true : false}>
      {label && <Typography variant="button">{label}</Typography>}
      {label && <Spacer h={0.5} />}
      <CKEditor
        editor={Editor}
        /*config={{
          //plugins: [FontColor],
          toolbar: ["bold", "italic", "fontSize"]
        }}*/
        //data="<p>Hello from CKEditor 5!</p>"
        data={value || ""}
        onReady={(editor: any) => {
          const v = editor.getData();
          if (v !== value) {
            editor.setData(value || "");
          }

          editorRef.current = editor;

          if (minHeight) {
            editor.editing.view.change((writer: any) => {
              writer.setStyle(
                "min-height",
                `${minHeight}px`,
                editor.editing.view.document.getRoot()
              );
            });
          }

          // You can store the "editor" and use when it is needed.
        }}
        onChange={(event: any, editor: any) => {
          const data = editor.getData();

          handleChange(data);
        }}
        onBlur={(event: any, editor: any) => {
          const data = editor.getData();
          handleBlur(data);
        }}
        onFocus={(event: any, editor: any) => {}}
        {...editorProps}
      />
      {(error || helperText) && (
        <FormHelperText error={error ? true : false}>
          {error || helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}

// FILECONTENT_END src/common/components/Inputs/HtmlEditor/HtmlEditor.tsx
